var _excluded = ["id", "items", "placement", "trigger", "disabled", "menuRole", "menuItemRole", "closeOnSelect", "onToggle", "onItemSelect", "onIndexChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useRef, useCallback, useEffect, useMemo, forwardRef } from 'react';
import { DropdownUncontrolled } from './DropdownUncontrolled';
import { useKeyboardNavigation, INITIAL_INDEX } from './keyboardNavigation';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Dropdown/withAssistiveDropdown');

/**
 * Декорирует переданный компонент, выводя доступный dropdown.
 */
export var withAssistiveDropdown = function withAssistiveDropdown(Component) {
  var Dropdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DropdownUncontrolled;
  return /*#__PURE__*/forwardRef(function (_ref, ref) {
    var id = _ref.id,
        items = _ref.items,
        placement = _ref.placement,
        trigger = _ref.trigger,
        disabled = _ref.disabled,
        menuRole = _ref.menuRole,
        menuItemRole = _ref.menuItemRole,
        _ref$closeOnSelect = _ref.closeOnSelect,
        closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
        onToggleExternal = _ref.onToggle,
        onItemSelectExternal = _ref.onItemSelect,
        onIndexChangeExternal = _ref.onIndexChange,
        rest = _objectWithoutProperties(_ref, _excluded);

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpen = _useState2[0],
        setIsOpen = _useState2[1];

    var _useState3 = useState(INITIAL_INDEX),
        _useState4 = _slicedToArray(_useState3, 2),
        index = _useState4[0],
        setIndex = _useState4[1];

    var openingMethod = useRef(null);
    var activeIndex = useMemo(function () {
      return items.findIndex(function (item) {
        return item.isActive;
      });
    }, [items]);
    var onToggle = useCallback(function (newIsOpen, event) {
      if (newIsOpen) {
        openingMethod.current = event.type;
      }

      setIsOpen(newIsOpen);
      onToggleExternal === null || onToggleExternal === void 0 ? void 0 : onToggleExternal(newIsOpen, event);
    }, [onToggleExternal]);
    var onItemSelect = useCallback(function (item, event) {
      if (item.isDisabled) {
        return;
      }

      if (closeOnSelect) {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(false, event);
      }

      onItemSelectExternal === null || onItemSelectExternal === void 0 ? void 0 : onItemSelectExternal(item, event);
    }, [onToggle, onItemSelectExternal, closeOnSelect]);
    var onIndexChange = useCallback(function (i) {
      setIndex(i);
      onIndexChangeExternal === null || onIndexChangeExternal === void 0 ? void 0 : onIndexChangeExternal(i);
    }, [onIndexChangeExternal]);
    var onBlur = useCallback(function () {
      if (openingMethod.current === 'keydown') {
        setIsOpen(false);
        setIndex(INITIAL_INDEX);
      }
    }, []);
    var onHover = useCallback(function (newIndex) {
      setIndex(newIndex);
    }, []);
    var onMouseLeave = useCallback(function () {
      setIndex(-1);
    }, []);

    var _useKeyboardNavigatio = useKeyboardNavigation({
      items: items,
      isOpen: isOpen,
      index: index,
      onToggle: onToggle,
      onItemSelect: onItemSelect,
      onIndexChange: onIndexChange
    }),
        onKeyDown = _useKeyboardNavigatio.onKeyDown;

    useEffect(function () {
      setIndex(activeIndex);
    }, [activeIndex]);
    useEffect(function () {
      if (!isOpen) {
        onIndexChange === null || onIndexChange === void 0 ? void 0 : onIndexChange(activeIndex === -1 ? INITIAL_INDEX : activeIndex);
      }
    }, [isOpen, onIndexChange, activeIndex]);
    return /*#__PURE__*/React.createElement(Dropdown, {
      id: id,
      role: menuRole,
      itemRole: menuItemRole,
      "aria-labelledby": id ? "".concat(id, "-disclosure") : undefined,
      isOpen: isOpen,
      items: items,
      placement: placement,
      trigger: trigger,
      disabled: disabled,
      hoverIndex: index,
      onBlur: onBlur,
      onKeyDown: onKeyDown,
      onToggle: onToggle,
      onItemSelect: onItemSelect,
      onHover: onHover,
      onMouseLeave: onMouseLeave
    }, /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
      ref: ref,
      id: id ? "".concat(id, "-disclosure") : undefined,
      isOpen: isOpen,
      disabled: disabled,
      "aria-activedescendant": id && index >= 0 ? "".concat(id, "-item-").concat(index) : undefined,
      "aria-controls": id,
      "aria-expanded": isOpen,
      "aria-haspopup": menuRole
    })));
  });
};